import { useEffect, useState, type CSSProperties } from 'react';
import { Link } from 'react-router-dom';

import { useI18n } from '@/providers/i18n';

import styles from './HomeHero.module.css';

interface HomeHeroProps {
  nextEventId: string;
}

export default function HomeHero({ nextEventId }: HomeHeroProps) {
  const { t } = useI18n();
  const [rev, setRev] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = window.innerHeight * 0.6;
      setRev(Math.min(100, (window.scrollY / max) * 100));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className={styles.root}>
      <div className={styles.frame}>
        <div className={styles.eyebrow}>
          <span className="dot breathe" aria-hidden="true" />
          <span>SIGNAL ON</span>
          <span className={styles.eyebrowSpacer} aria-hidden="true" />
          <span className="paren">SEVEN YEARS</span>
          <span className="fg-dim">·</span>
          <span>EST. 2019</span>
        </div>

        <h1 className={`${styles.mega} tight`}>
          <span
            className={styles.scrub}
            style={{ ['--rev' as string]: `${rev}%` } as CSSProperties}
          >
            {t('home.hero.l1')}
          </span>
          <br />
          <span
            className={styles.scrub}
            style={{ ['--rev' as string]: `${Math.max(0, rev - 20)}%` } as CSSProperties}
          >
            {t('home.hero.l2')}
          </span>
        </h1>

        <div className={styles.sub}>
          <span>{t('home.tag')}</span>
        </div>

        <div className={styles.bottom}>
          <p className={styles.intro}>{t('home.intro')}</p>
          <div className={styles.side}>
            <div className={styles.metaRow}>
              <span>YEREVAN / ARMENIA</span>
              <span>40.18°N / 44.51°E</span>
              <span>SYSTEM 0.7</span>
            </div>
            <div className={styles.cta}>
              <Link to="/events" className="btn btn-fill btn-arrow">
                {t('label.upcoming')}
              </Link>
              <Link to={`/events/${nextEventId}`} className="btn">
                {t('cta.tickets')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
